module.exports = __webpack_public_path__ + "static/media/Superman.c74bbe4a.jpg";